import { Operator } from '@services/core-services/filters/operator';
import { FilterEntry } from '@services/core-services/filters/filter-query';

export const OperatorRegistry: { [key in Operator]: string } = {
  [Operator.Equals]: 'equals',
  [Operator.NotEquals]: 'not equals',
  [Operator.Contains]: 'contains',
  [Operator.NotContains]: 'not contains',
  [Operator.StartsWith]: 'starts with',
  [Operator.EndsWith]: 'ends with',
  [Operator.IsEmpty]: 'empty',
  [Operator.IsNotEmpty]: 'not empty',
  [Operator.RegexMatch]: 'regex match',
  [Operator.GreaterThan]: 'gt',
  [Operator.GreaterThanOrEqualTo]: 'gte',
  [Operator.LessThan]: 'lt',
  [Operator.LessThanOrEqualTo]: 'lte',
  [Operator.Between]: 'between',
  [Operator.In]: 'in',
  [Operator.NotIn]: 'not in',
  [Operator.Exists]: 'exists',
  [Operator.NotExists]: 'not exists',
  [Operator.Before]: 'before',
  [Operator.After]: 'after',
  [Operator.LastX]: 'last',
  [Operator.HasBeenPerformed]: 'performed',
  [Operator.HasNotBeenPerformed]: 'not_performed',
  [Operator.HasBeenPerformedInPeriod]: 'performed_in_period',
};

export const getReadableName = (operator: Operator, rule?: FilterEntry) => {
  switch (operator) {
    case Operator.Equals:
      return 'equals';
    case Operator.NotEquals:
      return 'not equals';
    case Operator.Contains:
      return 'contains';
    case Operator.NotContains:
      return 'not contains';
    case Operator.StartsWith:
      return 'starts with';
    case Operator.EndsWith:
      return 'ends with';
    case Operator.IsEmpty:
      return 'is empty';
    case Operator.IsNotEmpty:
      return 'not empty';
    case Operator.RegexMatch:
      return 'regex match';
    case Operator.GreaterThan:
      return 'greater than';
    case Operator.GreaterThanOrEqualTo:
      return 'greater than or equal';
    case Operator.LessThan:
      return 'less than';
    case Operator.LessThanOrEqualTo:
      return 'less than or equal';
    case Operator.Between:
      return 'between';
    case Operator.In:
      return 'in';
    case Operator.NotIn:
      return 'not in';
    case Operator.Exists:
      return 'exists';
    case Operator.NotExists:
      return 'not exists';
    case Operator.Before:
      return 'before';
    case Operator.After:
      return 'after';
    case Operator.LastX:
      return 'last';
    case Operator.HasBeenPerformed:
      return 'performed';
    case Operator.HasNotBeenPerformed:
      return 'not performed';
    default:
      return 'unknown';
  }
};
